import { render } from "./ExercisePrim.vue?vue&type=template&id=7740d66d"
import script from "./ExercisePrim.vue?vue&type=script&lang=js"
export * from "./ExercisePrim.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__